import { render } from "./prize_order.vue?vue&type=template&id=3b7ac1f2"
import script from "./prize_order.vue?vue&type=script&lang=js"
export * from "./prize_order.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__